import { db } from "#/mixins/firebase";

async function getSingle(collection_id: string, document_id: string) {
  const doc = await db
    .collection(collection_id)
    .doc(document_id)
    .get();
  return doc.exists ? doc.data() : undefined;
}

async function setSingle(
  collection_id: string,
  document_id: string,
  data: object
) {
  await db
    .collection(collection_id)
    .doc(document_id)
    .set(data);
}

async function retry<T>(action: () => Promise<T>, maxRetries = 5): Promise<T> {
  for (let retries = 0; retries < maxRetries; retries++) {
    try {
      return await action();
    } catch (error) {
      console.error(`エラーが発生しました: ${error}`);
      if (retries > maxRetries) {
        console.error("最大リトライ回数を超えました。処理を中止します。");
        throw error;
      }
      console.log(`リトライします (${retries + 1}/${maxRetries})...`);
    }
  }
  // 型的にはここに来ないが、return が必須のため
  throw new Error("Unexpected error in retry()");
}

async function getFirestore(collection_id: string, document_id: string) {
  return await retry(() => getSingle(collection_id, document_id));
}

async function setFirestore(
  collection_id: string,
  document_id: string,
  data: object
) {
  return await retry(() => setSingle(collection_id, document_id, data));
}

export { getFirestore, setFirestore, retry };
